import { render, staticRenderFns } from "./BCXMessenger.vue?vue&type=template&id=640a4e80&scoped=true"
import script from "./BCXMessenger.vue?vue&type=script&lang=ts"
export * from "./BCXMessenger.vue?vue&type=script&lang=ts"
import style0 from "./BCXMessenger.vue?vue&type=style&index=0&id=640a4e80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640a4e80",
  null
  
)

export default component.exports